import type { RouteSummary } from "~/api/types";

export function getRouteScoreUsd(
  summary: Pick<RouteSummary, "netOutputUsd" | "toAmountUsdAfterGas" | "toAmountUsd">,
): number | null {
  const candidates = [summary.netOutputUsd, summary.toAmountUsdAfterGas, summary.toAmountUsd];

  for (const candidate of candidates) {
    const value = Number(candidate);
    if (Number.isFinite(value)) {
      return value;
    }
  }

  return null;
}
